// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1lkiu","index":"styles_index__3B1bV"};